import React from 'react';
import { Oval } from 'react-loader-spinner';
import { ProgressBar } from './ProgressBar';
import { useUploadProgress } from '../context/UploadProgressContext';
import '../assets/styles/globalUploadProgress.scss';

export const GlobalUploadProgress = () => {
  const { isUploading, percentage, stepName } = useUploadProgress();

  if (!isUploading) {
    return null;
  }

  return (
    <div className="global-upload-progress">
      <div className="upload-progress-overlay">
        <div className="upload-progress-content">
          <div className="upload-spinner">
            <Oval
              height={100}
              width={100}
              color="#00B1B7"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="upload-loading"
              secondaryColor="#00B1B7"
              strokeWidth={4}
              strokeWidthSecondary={2}
            />
          </div>

          <div className="upload-progress">
            <ProgressBar
              percentage={percentage}
              label=""
              showPercentage={true}
              color="#00B1B7"
              height="14px"
            />
            <div className="upload-step-name">
              {stepName}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};